import { render, staticRenderFns } from "./water.vue?vue&type=template&id=17b4f92d&scoped=true"
import script from "./water.vue?vue&type=script&lang=js"
export * from "./water.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=17b4f92d&prod&scoped=true&lang=css&external"
import style1 from "./water.vue?vue&type=style&index=1&id=17b4f92d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4f92d",
  null
  
)

export default component.exports